const params = new URLSearchParams(location.search)

export const language = params.get('language') || 'en'
